import { render, staticRenderFns } from "./ReasonEditSelect.vue?vue&type=template&id=6aac8ccc&scoped=true&"
import script from "./ReasonEditSelect.vue?vue&type=script&lang=js&"
export * from "./ReasonEditSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aac8ccc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
